import React, { useContext } from 'react'
import './style/Q3.css'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import YesOrNoQuestion from '../YesOrNoQuestion'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import StepCounter from '../StepCounter'
import gif3 from './assets/02_plane.gif'
import jpg3 from './assets/static/02_plane.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q3() {
    const { settings } = useContext(AppContext)

    const history = useHistory();
    const { translate } = useLocalize()
    return (
        <>
            <div className="picHold hid vis">
                <img className="gif3" src={settings.isAnimationPause ? jpg3 : gif3} />
            </div>
            <Headling text={translate('Prepare for Takeoff')} />
            <Subtitle text={translate('Do I vacation overseas at least once a year?')} />
            <YesOrNoQuestion onYesClick={() => {
                setNewAnswer({
                    3: 1,
                }
                )
                history.push('/Q/4')
                ReactPixel.trackCustom('fly_yes', '');
            }}
                onNoClick={() => {
                    setNewAnswer({
                        3: 0,

                    })
                    history.push('/Q/4')
                    ReactPixel.trackCustom('fly_no', '');
                }} />
            <StepCounter />
        </>
    )
}



export default Q3

